"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = exports.Box = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("@styled-system/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var boxProps = (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.color, _styledSystem.layout, _styledSystem.typography, _styledSystem.flexbox);
var Box = (0, _styledComponents["default"])('div').withConfig({
  displayName: "src__Box",
  componentId: "sc-1sbtrzs-0"
})({
  boxSizing: 'border-box'
}, boxProps);
exports.Box = Box;
Box.displayName = 'Box';
Box.propTypes = _objectSpread({}, _propTypes["default"].space, {}, _propTypes["default"].color, {}, _propTypes["default"].layout, {}, _propTypes["default"].typography, {}, _propTypes["default"].flexbox);
var Flex = (0, _styledComponents["default"])(Box).withConfig({
  displayName: "src__Flex",
  componentId: "sc-1sbtrzs-1"
})({
  display: 'flex'
});
exports.Flex = Flex;
Flex.displayName = 'Flex';